import { useContext } from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';
import IntroStep from './IntroStep';
import OnboardingWizard from './OnboardingWizard';
import EntraOnboardingWizard from './EntraOnboardingWizard';
import ThankYouStep from './ThankYouStep';
import './Onboarding.scss';

const Onboarding = () => {
  const { authMethod } = useContext(UserContext);
  const RegistrationWizard = authMethod === 'entra' ? EntraOnboardingWizard : OnboardingWizard;

  return (
    <div className="onboarding-container">
      <div className="onboarding-content-wrapper">
        <Routes>
          <Route path="/" element={<IntroStep />} />
          <Route path="/register" element={<RegistrationWizard />} />
          {/* The old Entra waiting page; /welcome now shows a pending request. */}
          <Route path="/pending-approval" element={<Navigate replace to="/welcome" />} />
          <Route path="/thank-you" element={<ThankYouStep />} />
        </Routes>
      </div>
    </div>
  );
};

export default Onboarding;